<div class="statement-loading-dialog">
    <h2 class="statement-loading-dialog__title">{{ title }}</h2>
    <div class="statement-loading-dialog__progress-track">
        <div class="statement-loading-dialog__progress-fill" [style.width.%]="progress"></div>
    </div>
    <p class="statement-loading-dialog__message">{{ message }}</p>
</div>